import React, { useState } from 'react'
import { Layout, Menu, ConfigProvider } from 'antd'
import { Link } from 'react-router-dom';
// import logo from '../../assets/images/logo.png'
// import icon from '../../assets/images/icon.png'
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { AppAction } from '../../store/actions'
import ButtonLoader from "../../components/Button/ButtonLoader";

// import BasicModal from '../../components/Modal/BasicModal'

// ICONS IMPORT
import { RxDashboard } from "react-icons/rx";
import { AiFillAlert } from "react-icons/ai";
import { MdOutlineManageAccounts } from "react-icons/md";
import { FaSitemap } from "react-icons/fa6";
import { FaUserAlt } from "react-icons/fa";
import { PiUsersThreeDuotone } from "react-icons/pi";
import { FaCalendarAlt } from "react-icons/fa";
import { FaFacebookMessenger } from "react-icons/fa";
import { FaUsersRays } from "react-icons/fa6";
import { IoSettingsSharp } from "react-icons/io5";

import siteLogo from '../../assets/images/siteLogo.png'
import siteLogoCopy from '../../assets/images/siteLogo - Copy.png'
import { IoLogOutSharp } from "react-icons/io5";
import Colors from '../../config/colors';


const AdminSideBar = () => {

    const { Sider } = Layout;
    const [collapsed, setCollapsed] = useState(false);
    const [logoutModal, setLogoutModal] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const loader = useSelector((state) => state?.AppReducer.loader);
    const currentLocation = location?.pathname;

    // console.log("Location",location.pathname)

    // console.log("Location",window.location.pathname);
    console.log("current location", currentLocation)


    const logoutModalViewer = () => {
        setLogoutModal(true);
    }


    const logOut = () => {
        const payload = {
            from_everywhere: true
        }
        dispatch(AppAction.Logout(payload, () => {
            navigate('/logout')
        }))

    }


    return (
        <>
            <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                className=''
                style={{
                    overflow: 'auto',
                    // height: '100vh',
                    // position: 'fixed',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    zIndex: 999
                }}

                theme='light'
                breakpoint='lg'
                onCollapse={() => setCollapsed(!collapsed)}
                width={260}
            >

                <div className="demo-logo-vertical" />
                <ConfigProvider
                    theme={{
                        components: {
                            Menu: {
                                // Background color of menu item when selected
                                itemSelectedBg: '',
                                // Color of selected menu item text	
                                itemSelectedColor: '',
                                fontSize: collapsed ? 14 : 13
                            },
                        },
                    }}
                >

                    <Menu
                        theme="light"
                        mode="inline"
                        defaultSelectedKeys='1'
                        className='h-full'
                        style={{ height: '90vh', padding: '0px 3px', }}
                    >
                        {/* have to perform this inline stylng for bg and color , as on refresh of a page it will make the key = 1 and set the bg and color for dashboard whereas our current location is still pointing to where we are previously standing e.g user management */}
                        <>
                            {collapsed ?
                                <Link to="/">
                                    <img className='mt-4 mx-auto py-0 px-2 mb-4' style={{ width: '65px', height: '50px' }} src={siteLogoCopy} />
                                </Link>
                                :
                                <Link to="/">
                                    <img style={{ width: '200px', height: '60px' }} className='mt-4 mx-auto py-0 px-2 mb-2' src={siteLogo} />
                                </Link>

                            }

                            <Menu.Item style={{ background: currentLocation === '/' ? Colors.Yellow : '', color: currentLocation === '/' ? Colors.White : Colors.MenuItem }} className="menu-item" key="1"
                                icon={
                                    <div style={{ padding: '3px', background: currentLocation === '/' ? '#2F3032' : '#EEF4FF', borderRadius: '5px' }}>
                                        <RxDashboard style={{ paddingRight: collapsed ? '0px' : '', paddingTop: collapsed ? '0px' : '' }} size={15} color={currentLocation === '/' ? Colors.White : Colors.Yellow} />
                                    </div>
                                }>
                                <Link to="/">Dashboard</Link>
                            </Menu.Item>

                            <Menu.Item style={{ background: currentLocation === '/emergency-alert' ? Colors.Yellow : '', color: currentLocation === '/emergency-alert' ? Colors.White : Colors.MenuItem }} className="menu-item" key="2"
                                icon={
                                    <div style={{ padding: '3px', background: currentLocation === '/emergency-alert' ? '#2F3032' : '#EEF4FF', borderRadius: '5px' }}>
                                        <AiFillAlert style={{ paddingRight: collapsed ? '0px' : '', paddingTop: collapsed ? '0px' : '' }} size={15} color={currentLocation === '/emergency-alert' ? Colors.White : Colors.Yellow} />
                                    </div>
                                }>
                                <Link to="/emergency-alert">Emergency Alert</Link>
                            </Menu.Item>

                            <Menu.Item style={{ background: currentLocation === '/users-management' ? Colors.Yellow : '', color: currentLocation === '/users-management' ? Colors.White : Colors.MenuItem }} className="menu-item" key="3"
                                icon={
                                    <div style={{ padding: '3px', background: currentLocation === '/users-management' ? '#2F3032' : '#EEF4FF', borderRadius: '5px' }}>
                                        <MdOutlineManageAccounts style={{ paddingRight: collapsed ? '0px' : '', paddingTop: collapsed ? '0px' : '' }} size={15} color={currentLocation === '/users-management' ? Colors.White : Colors.Yellow} />
                                    </div>
                                }>
                                <Link to="/users-management">User Management</Link>
                            </Menu.Item>

                            <Menu.Item style={{ background: currentLocation === '/site-management' ? Colors.Yellow : '', color: currentLocation === '/site-management' ? Colors.White : Colors.MenuItem }} className="menu-item" key="4"
                                icon={
                                    <div style={{ padding: '3px', background: currentLocation === '/site-management' ? '#2F3032' : '#EEF4FF', borderRadius: '5px' }}>
                                        <FaSitemap style={{ paddingRight: collapsed ? '0px' : '', paddingTop: collapsed ? '0px' : '' }} size={15} color={currentLocation === '/site-management' ? Colors.White : Colors.Yellow} />
                                    </div>
                                }>
                                <Link to="/site-management">Site Management</Link>
                            </Menu.Item>

                            <Menu.Item style={{ background: currentLocation === '/client-support' ? Colors.Yellow : '', color: currentLocation === '/client-support' ? Colors.White : Colors.MenuItem }} className="menu-item" key="5"
                                icon={
                                    <div style={{ padding: '3px', background: currentLocation === '/client-support' ? '#2F3032' : '#EEF4FF', borderRadius: '5px' }}>
                                        <FaUserAlt style={{ paddingRight: collapsed ? '0px' : '', paddingTop: collapsed ? '0px' : '' }} size={15} color={currentLocation === '/client-support' ? Colors.White : Colors.Yellow} />
                                    </div>
                                }>
                                <Link to="/client-support">Client Management</Link>
                            </Menu.Item>
                            <Menu.Item style={{ background: currentLocation === '/workforce-management' ? Colors.Yellow : '', color: currentLocation === '/workforce-management' ? Colors.White : Colors.MenuItem }} className="menu-item" key="6"
                                icon={
                                    <div style={{ padding: '3px', background: currentLocation === '/workforce-management' ? '#2F3032' : '#EEF4FF', borderRadius: '5px' }}>
                                        <PiUsersThreeDuotone style={{ paddingRight: collapsed ? '0px' : '', paddingTop: collapsed ? '0px' : '' }} size={20} color={currentLocation === '/workforce-management' ? Colors.White : Colors.Yellow} />
                                    </div>
                                }>
                                <Link to="/workforce-management">Workforce Management</Link>
                            </Menu.Item>
                            <Menu.Item style={{ background: currentLocation === '/attendance-management' ? Colors.Yellow : '', color: currentLocation === '/attendance-management' ? Colors.White : Colors.MenuItem }} className="menu-item" key="7"
                                icon={
                                    <div style={{ padding: '3px', background: currentLocation === '/attendance-management' ? '#2F3032' : '#EEF4FF', borderRadius: '5px' }}>
                                        <FaCalendarAlt style={{ paddingRight: collapsed ? '0px' : '', paddingTop: collapsed ? '0px' : '' }} size={15} color={currentLocation === '/attendance-management' ? Colors.White : Colors.Yellow} />
                                    </div>
                                }>
                                <Link to="/attendance-management">Attendance Management</Link>
                            </Menu.Item>
                            <Menu.Item style={{ background: currentLocation === '/security-issues' ? Colors.Yellow : '', color: currentLocation === '/security-issues' ? Colors.White : Colors.MenuItem }} className="menu-item" key="8" icon={
                                <div style={{ padding: '3px', background: currentLocation === '/security-issues' ? '#2F3032' : '#EEF4FF', borderRadius: '5px' }}>
                                    <FaFacebookMessenger style={{ paddingRight: collapsed ? '0px' : '', paddingTop: collapsed ? '0px' : '' }} size={15} color={currentLocation === '/security-issues' ? Colors.White : Colors.Yellow} />
                                </div>
                            }>
                                <Link to="/security-issues">Security Issues</Link>
                            </Menu.Item>
                            <Menu.Item style={{ background: currentLocation === '/connectivity-hub' ? Colors.Yellow : '', color: currentLocation === '/connectivity-hub' ? Colors.White : Colors.MenuItem }} className="menu-item" key="9"
                                icon={
                                    <div style={{ padding: '3px', background: currentLocation === '/connectivity-hub' ? '#2F3032' : '#EEF4FF', borderRadius: '5px' }}>
                                        <FaUsersRays style={{ paddingRight: collapsed ? '0px' : '', paddingTop: collapsed ? '0px' : '' }} size={15} color={currentLocation === '/connectivity-hub' ? Colors.White : Colors.Yellow} />
                                    </div>
                                }>
                                <Link to="/connectivity-hub">Connectivity Hub</Link>
                            </Menu.Item>
                            <Menu.Item style={{ background: currentLocation === '/setting' ? Colors.Yellow : '', color: currentLocation === '/setting' ? Colors.White : Colors.MenuItem }} className="menu-item" key="10"
                                icon={
                                    <div style={{ padding: '3px', background: currentLocation === '/setting' ? '#2F3032' : '#EEF4FF', borderRadius: '5px' }}>
                                        <IoSettingsSharp style={{ paddingRight: collapsed ? '0px' : '', paddingTop: collapsed ? '0px' : '' }} size={15} color={currentLocation === '/setting' ? Colors.White : Colors.Yellow} />
                                    </div>
                                }>
                                <Link to="/setting">Setting</Link>
                            </Menu.Item>


                        </>

                    </Menu>

                </ConfigProvider>



                <div className='flex items-center justify-center mx-5  gap-1.5 py-3 rounded-md' style={{ background: Colors.LightBlack }}>
                    <ButtonLoader icon={<IoLogOutSharp size={25} color={Colors.White} />} loader={loader} text={collapsed ? '' : 'Log Out'} btnHandler={logOut} style={{ background: "#2f3032", color: Colors.White, outline: 'none', border: 'none' }} className="flex items-center justify-center cursor-pointer text-center w-full text-base tracking-wider" />
                </div>

            </Sider>

            {/* {

                <BasicModal
                    centered={'centered'}
                    width={'300px'}
                    modalType={'basicModal'}
                    text='Are you sure, you want to logout ?'
                    descriptionStyle={{ textAlign: 'center', fontSize: '1.3rem', fontWeight: '500', margin: '10px' }}
                    isModalOpen={logoutModal}
                    isFooter={true}
                    leftButtonText='yes'
                    rightButtonText="no"
                    rightButtonStyle={{ backgroundColor: 'black', color: 'white' }}
                    leftButtonStyle={{ backgroundColor: 'green', color: 'white' }}
                    onClickLeft={logOut} onClickRight={() => setLogoutModal(false)}
                    onCancel={() => setLogoutModal(false)} />
            } */}

        </>
    )
}

export default AdminSideBar